export default __webpack_public_path__ + "static/media/ma_ trans.2f5f41d2.png";